import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ContentfulService} from '../../services/contentful.service';
import {LiveEvent, LiveEventAdapter} from '../../models/live-event/live-event';
import {AngularFireAuth} from '@angular/fire/auth';
import {first, take} from 'rxjs/operators';
import {AngularFireFunctions} from '@angular/fire/functions';
import {AngularFireDatabase} from '@angular/fire/database';
declare var WowzaPlayer: any;
import * as moment from 'moment';
import {loadStripe} from '@stripe/stripe-js/pure';
const stripePromise = loadStripe('pk_live_Alk04fb7KAp2n3KW359tLAuI');
// const stripePromise = loadStripe('sk_test_HqLyTcK9IBh6XaVbfMSV6Ldd00y1Ssgcem');

@Component({
  selector: 'app-watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss'],
})
export class WatchComponent implements OnInit, OnDestroy {
  stripeFunction: any;
  stripeSessionId: any;
  userId: string;
  videoId: string;
  video: LiveEvent;
  wowzaReleased = true;
  purchases;
  loading = false;
  wowzaPlayer: any;
  showCheckoutButton = true;
  showPaywall = false;
  showPlayer = false;
  formattedStartTime: string;
  error = false;
  playerId;
  errorMessage = '';
  videoType = 'application/x-mpegURL';
  /* Temporary: Doing this so that the only video id required to bypass purchase it the channel live stream id */
  globalVideoId = "2F3wTjs5NkTz9XvuMeQZXT";

  constructor(private route: ActivatedRoute, private router: Router, private db: AngularFireDatabase, private contentfulService: ContentfulService, private firebaseAuth: AngularFireAuth, private fns: AngularFireFunctions) {
    this.route.paramMap.subscribe(params => {
      this.videoId = params.get('id');
    });
    this.stripeFunction = fns.httpsCallable('stripe-createStripeSession');
  }

  ngOnInit() {
      this.firebaseAuth.authState.pipe(take(1)).subscribe(auth => {
        if (auth) {
          this.userId = auth.uid;
          this.purchases = this.db.list(`users/${this.userId}/purchases`).valueChanges().subscribe((purchases: any) => {
            this.contentfulService.getEntry(this.videoId).then((res) => {
              const contentType = res.sys.contentType.sys.id;
              this.videoType = contentType === 'onDemandEvent' ? 'video/mp4' : this.videoType;
              const idToMatch = contentType === 'onDemandEvent' ? this.globalVideoId : this.videoId;
              const match = purchases.filter((purchase) => (purchase.entryId === idToMatch));
              this.video = new LiveEventAdapter().creatLiveEventFromEntry(res);
              const d = new Date(this.video.startTime);
              const diff = moment().diff(d, 'days');
              this.formattedStartTime = moment(d).calendar();
              if (contentType !== 'onDemandEvent' && diff > 0) {
                this.router.navigate(['']);
              } else if (match.length || this.contentfulService.allAccess || this.video.planPrice === 0) {
                this.showPaywall = false;
                this.showPlayer = true;
                this.wowzaReleased = false;
                // this.wowzaPlayer = WowzaPlayer.create("playerElement",
                //   {
                //     "license": "PLAY1-k8cZV-MfRtB-Qa48U-8bHeT-ZH3PA",
                //     "sources": [{
                //       "sourceURL": this.video.endpoint
                //     }],
                //     title: this.video.title,
                //     description: this.video.description,
                //     autoPlay: false,
                //     mute: false,
                //     uiShowChannelBug: (this.video.sponsor) ? "true" : "false",
                //     uiChannelBugURL: this.video.sponsor,
                //     uiChannelBugLocation: "topleft",
                //     posterFrameURL: this.video.posterImage,
                //     volume: 75,
                //     onError: (err) => {
                //       console.error(err);
                //     }
                //   }
                // );
              } else {
                this.showPlayer = false;
                this.showPaywall = true;
               }
            });
          });
        } else {
          this.showPaywall = true;
        }
      });
  }


  goToStripeCheckout() {
    this.stripeFunction({ entryId: this.videoId, planId: this.video.planId, eventTitle: this.video.title, recurring: this.video.recurring}).subscribe(async (res) => {
      const stripe = await stripePromise;
      this.stripeSessionId = res.session.id;
      return stripe.redirectToCheckout({
        sessionId: res.session.id
      })
        .then((result) => {
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
          console.error("ERR", result.error);
          if (result.error) {
            this.error = true;
            this.errorMessage = "There was an error launching checkout with this device, please try again. If this issue continues, try a different device."
          }
        });
    });
  }

  async launchStripeCheckout() {
    const stripe = await stripePromise;
    return stripe.redirectToCheckout({
      sessionId: this.stripeSessionId
    });
  }

  async createStripePaymentIntent() {
    const stripe = await stripePromise;
    const elements = stripe.elements();
  }

  ngOnDestroy() {
    if (this.wowzaPlayer) {
      this.wowzaPlayer.destroy();
    }
    this.wowzaReleased = true;
  }

  canDeactivate() {
    if (this.wowzaPlayer && !this.wowzaReleased) {
      this.wowzaPlayer.destroy();
      return true;
    } else {
      return true;
    }
  }

}
